import { LazyLoadUtils } from "../../utils/index.js";

export const loadSecondaryMenuComponent = (brandId, clientProvider) => {
  const dynamicPart = `${brandId}/${clientProvider}/`;

  return LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${dynamicPart}SecondaryMenu.layout.js`
      ),
    { componentName: "loadSecondaryMenuComponent" }
  );
};

export const preload = ({ clientProvider, brandId }) => {
  loadSecondaryMenuComponent(brandId, clientProvider).preload();
};
